'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function reverse(array) {
    if (array == null) {
        return array;
    }
    return array.reverse();
}

exports.reverse = reverse;
